import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1ca6530"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "chat",
  class: "flex-grow-1"
}
const _hoisted_2 = { class: "title-row p-3" }
const _hoisted_3 = {
  key: 1,
  class: "messages p-3"
}
const _hoisted_4 = { class: "chat-input" }
const _hoisted_5 = ["disabled"]

import GuildChatMessage from './GuildChatMessage.vue';
import { ref, watch } from 'vue';

import { Form, Field } from 'vee-validate';
import * as yup from 'yup';

import { useGuildStore } from '@/stores/GuildStore';
import { useChatStore } from '@/stores/ChatStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildChat',
  setup(__props) {

const guildStore = useGuildStore();
const chatStore = useChatStore();

const scrollContainerRef = ref<HTMLDivElement | null>(null);
const formValues = ref({
  message: ''
});
const firstAutoScrollDone = ref(false);
const scrolledToBottom = ref(false);
const lastViewedMessageId = ref<string | null>(null);
const firstViewedMessageId = ref<string | null>(null);

const schema = yup.object({
  message: yup.string().min(1).required(),
});

function onSubmit(values: any, { resetForm }: any) {
  chatStore.sendMessage(values.message as string);
  resetForm();
}

function scrollToBottom(){
  if(scrollContainerRef.value){
    scrollContainerRef.value.scrollTop = scrollContainerRef.value.scrollHeight;
  }
  if(firstAutoScrollDone.value === false){
    firstAutoScrollDone.value = true;
  }
}

const handleScroll = (e: Event) => {
  const target = e.target as HTMLDivElement;

  //scroll to bottom handler
  if (target.scrollHeight - target.scrollTop === target.clientHeight) {
    scrolledToBottom.value = true;
    lastViewedMessageId.value = chatStore.lastMessage?.id;
  } else {
    scrolledToBottom.value = false;
  }

  //fetch more messages handler
  if (target.scrollTop === 0) {
    firstViewedMessageId.value = chatStore.firstMessage?.id;
    chatStore.fetchOlderMessages();
  }
};

//Scrolls to bottom of chat when new messages are fetched
watch(
  () => ({
    firstMessage: chatStore.firstMessage,
    lastMessage: chatStore.lastMessage,
    messagesLoaded: chatStore.loaded,
    scrollContainer: scrollContainerRef.value
  }),
  ({ firstMessage, lastMessage, scrollContainer }) => {
    //I am at the bottom and recieve a new message
    if (lastMessage && scrollContainer && (scrolledToBottom.value === true  || firstAutoScrollDone.value === false)) {
      setTimeout(() => {
        lastViewedMessageId.value = lastMessage.id;
        console.log('scrolling to bottom');
        scrollToBottom();
      }, 0);
    }
    if(firstMessage && scrollContainer && firstViewedMessageId.value !== firstMessage.id){
      setTimeout(() => {
        const firstViewedMessage = document.getElementById(`${firstViewedMessageId.value}`);
        if(firstViewedMessage){
          firstViewedMessage.scrollIntoView();
        }
      }, 0);
    }
  }
);

//watch activeGuildId and if changes reset refs
watch(() => guildStore.activeChannel?.id, (newGuildId, oldGuildId) => {
  if (newGuildId && newGuildId !== oldGuildId) {
    console.log('resetting refs');
    firstViewedMessageId.value = null;
    lastViewedMessageId.value = null;
    firstAutoScrollDone.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_unref(guildStore).activeChannel?.name), 1)
    ]),
    (_unref(chatStore).loaded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "messages p-3",
          onScrollPassive: handleScroll,
          ref_key: "scrollContainerRef",
          ref: scrollContainerRef
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatStore).messages, (message) => {
            return (_openBlock(), _createBlock(GuildChatMessage, {
              class: "mb-2",
              key: message.id,
              message: message
            }, null, 8, ["message"]))
          }), 128))
        ], 544))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading... ")),
    (firstAutoScrollDone.value && !scrolledToBottom.value && _unref(chatStore).lastMessage?.id !== lastViewedMessageId.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "unread-notify",
          onClick: scrollToBottom
        }, " You have new unread messages "))
      : _createCommentVNode("", true),
    _createVNode(_unref(Form), {
      ref: "form",
      "validation-schema": _unref(schema),
      onSubmit: onSubmit
    }, {
      default: _withCtx(({ isSubmitting, meta}) => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Field), {
            type: "text",
            name: "message",
            value: formValues.value.message
          }, null, 8, ["value"]),
          _createElementVNode("button", {
            type: "submit",
            disabled: isSubmitting || !meta.valid,
            class: "hidden"
          }, " Send ", 8, _hoisted_5)
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})